import { AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';

export class CardAcceptanceChannelValidator {
    public static equals100 = (): ValidatorFn => {
        return (formGroup: FormGroup): { [key: string]: boolean } => {
            var inPersonCardAcceptanceChannel: AbstractControl = formGroup.get("inPersonCardAcceptanceChannel");
            var mailTelephoneCardAcceptanceChannel: AbstractControl = formGroup.get("mailTelephoneCardAcceptanceChannel");
            var websiteCommerceCardAcceptanceChannel: AbstractControl = formGroup.get("websiteCommerceCardAcceptanceChannel");
            var total = Number(inPersonCardAcceptanceChannel.value) + Number(mailTelephoneCardAcceptanceChannel.value) + Number(websiteCommerceCardAcceptanceChannel.value);
            return total === 100 ? null : { totalNot100: true };
        }
    }
}